import * as React from 'react';

import iconUrl from './icon_warning.svg';

export const IconWarning = () => <img src={iconUrl} alt="" />;
